import React from 'react'


const SearchFilter = () => {
    return (
        <div>
            <div class="card p-3">
                <form>
                    <div class="row g-3 align-items-center">
                        <div class="col-md-2">
                            <label for="project" class="form-label">Project</label>
                            <select id="project" class="form-select">
                                <option selected>Select Project</option>
                                <option value="1">Project 1</option>
                                <option value="2">Project 2</option>
                            </select>
                        </div>

                        <div class="col-md-2">
                            <label for="activityType" class="form-label">Activity Type</label>
                            <select id="activityType" class="form-select">
                                <option selected>Select Activity Types</option>
                                <option value="1">Type 1</option>
                                <option value="2">Type 2</option>
                            </select>
                        </div>

                        <div class="col-md-2">
                            <label for="dateRange" class="form-label">Date Range</label>
                            <select id="dateRange" class="form-select">
                                <option selected>Current Month</option>
                                <option value="1">Last Month</option>
                                <option value="2">Custom Range</option>
                            </select>
                        </div>

                        <div class="col-md-2">
                            <label for="team" class="form-label">Teams</label>
                            <select id="team" class="form-select">
                                <option selected>Select Team</option>
                                <option value="1">Team 1</option>
                                <option value="2">Team 2</option>
                            </select>
                        </div>

                        <div class="col-md-2">
                            <label for="assignedTo" class="form-label">Assigned To</label>
                            <select id="assignedTo" class="form-select">
                                <option selected>Select Sales Agent</option>
                                <option value="1">Agent 1</option>
                                <option value="2">Agent 2</option>
                            </select>
                        </div>

                        <div class="col-md-2">
                            <label for="status" class="form-label">Status</label>
                            <select id="status" class="form-select">
                                <option selected>Select Status</option>
                                <option value="1">Open</option>
                                <option value="2">Closed</option>
                            </select>
                        </div>

                        <div class="col-md-2">
                            <label for="assignedBy" class="form-label">Assigned By</label>
                            <select id="assignedBy" class="form-select">
                                <option selected>Select Sales Agent</option>
                                <option value="1">Agent 1</option>
                                <option value="2">Agent 2</option>
                            </select>
                        </div>

                        <div class="col-md-12 mt-3 text-end">
                            <button type="button" class="btn btn-primary me-2">Search</button>
                            <button type="button" class="btn btn-secondary me-2">Clear</button>

                        </div>
                    </div>
                </form>
            </div>
           
        </div>
    )
}

export default SearchFilter
